import { formatDate } from "@/common/utils/formatters";
import { format } from 'date-fns'
import { EquipmentModelFipePricesData } from "../types/equipmentModelFipePrices.type";

export class FipeDataTransformer {
  static chartTransformer() {
    return (fipePrices: EquipmentModelFipePricesData[]) => {
      return {
        data: fipePrices.map((fipePrice) => {
          const date = new Date(`${fipePrice.reference_year}-${fipePrice.reference_month}-01`)

          const formattedDate = format(date, 'MM/yy')

          return {
            value: Number(fipePrice.value),
            change_date: formatDate(date, true),
            formatted_date: formattedDate,
            object_id: '',
            object_type: ''
          };
        }),
        kind: 'line_chart',
        title: '',
        subtitle: '',
        primary: {
          query_identifier: 'formatted_date',
          format_parser: 'date',
        },
        width: 7,
        layout: 'horizontal',
        series_settings: {
          value: {
            query_identifier: 'value',
            label: 'Valor',
            stack_id: '',
            color: '#0b8ce9',
            format_parser: 'currency',
          },
        },
        tick_settings: {
          y: {
            format_parser: 'currency',
          }
        }
      };
    };
  }
}
